module.exports = __webpack_public_path__ + "static/media/github-logo-white.ce1eb381.svg";